import createCrudVuexModule from "@/store/crud";

export const question = createCrudVuexModule({
  namespaced: true,
  path: "/library/question",
});
export const questionSet = createCrudVuexModule({
  namespaced: true,
  path: "/library/question-set",
});

export const workspaceQuestionSet = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/question-set",
});
export const managementQuestionSet = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/question-set",
});

const taskDefinition = {
  state: { editedTask: undefined, tasks: [] },
  getters: { editedTask: (state) => state.editedTask, tasks: (state) => state.tasks },
  mutations: {
    tasks: (state, value) => (state.tasks = value ?? []),
    editedTask: (state, value) => (state.editedTask = value),

    addTaskItem: (state, { task }) => {
      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItem: (state, { task }) => {
      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      state.tasks = [...state.tasks.filter((t) => t._id != task._id)];
    },
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
    },
  },
  actions: {},
};

export const workspaceQuestion = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/question",

  state: { ...taskDefinition.state },
  getters: { ...taskDefinition.getters },
  mutations: { ...taskDefinition.mutations },
  actions: {
    ...taskDefinition.actions,
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
      commit("reset");
    },
  },
});

export const managementQuestion = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/question",

  state: { ...taskDefinition.state },
  getters: { ...taskDefinition.getters },
  mutations: { ...taskDefinition.mutations },
  actions: {
    ...taskDefinition.actions,
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
      commit("reset");
    },
  },
});
